import React from 'react'
import './s3.scss';
import {APP_LINK} from "../../../utils";

const S3 = () => {
  return (
    <div className="gogo-s-3">
      <p className="desc">
        "¡Solicita tu préstamo en minutos! Descarga nuestra app ahora y obtén el dinero que necesitas al instante."
      </p>
      <div className="spark-3 absolute"></div>
      <div className="dollar-5 absolute"></div>
      <div className="dollar-6 absolute"></div>
      {
        APP_LINK &&
        <a className="gp absolute" href={APP_LINK}></a>
      }
    </div>
  )
}

export default S3;
